import { Link } from "react-router-dom";
import React from "react";
import { ChevronLeft } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRoute, RouteId } from "@/routes/getRoute";

export const BackToContextLink = ({
  title,
  path,
  className,
}: {
  title: string;
  path: RouteId;
  className?: string;
}) => {
  const getRoute = useRoute();

  return (
    <Link className={cn("flex", className)} to={getRoute(path)}>
      <div className="inline-block rounded-4xl border px-1.5 py-0.5">
        <ChevronLeft size={16} />
      </div>
      <div className="text-muted-foreground-3 pl-1 font-light">{title}</div>
    </Link>
  );
};
